import React, { useState, useEffect } from "react";
import {
  DateInput,
  TextInput,
  SelectInput,
  FileInput,
  RadioInput,
  NumberInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import documentsSchema from "../../validation/documentsSchema";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication.js";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  documentsActions,
  masterActions,
  publicUserActions,
  revenueReportingActions,
  authActions,
} from "../../_store";
import { history } from "../../_helpers";
import Error from "../error/error";
import CustomLoader from "./../../components/common/ui/Loader";
import Table from "../../components/common/table/Table";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import { fDate, MinDate, Today } from "../../utils/formatTime";
import generateXlsx from "../../components/common/export/generateXlsx";
import { Popup } from "../../components/common/ui/NotificationModal/Popup";
import { StoredProcedures } from "../../_helpers/enumerator";

function PublicUserPayment() {
  const location = useLocation();
  const navigate = useNavigate();
  const { row, source, backTo, currentShowingTable } = location.state || {};
  const dispatch = useDispatch();
  const { user, commonFacilityCode } = useSelector((x) => x.auth);
  const {
    loadPaymentList,
    loadPaymentExcelList,
    loadPaymentConfirmCancel,
    PublicUserCurrentTab,
    infoInformationList,
    loading,
  } = useSelector((x) => x.publicUser);
  const rows = useSelector((x) => x?.publicUser?.PublicUserrow);
  const { paymentTypeOptions } = useSelector((x) => x.dropdownOptions);
  const { POTpaymentUpdate } = useSelector((x) => x.revenueReporting);
  const [paymentList, setpaymentList] = useState({
    userID: row?.PublicUserID || rows?.PublicUserID,
    transactionDate: "",
    poTransactionRandomID:
      source === "RevenueReport" ? row?.POTransactionRandomID : "",
    paymentType: "All",
    paymentStatus: "4",
    pageNo: 1,
    rowCountPerPage: 10,
    sortField: "",
  });

  const reset = {
    userID: row?.PublicUserID,
    transactionDate: "",
    poTransactionRandomID: "",
    paymentType: "All",
    paymentStatus: "4",
    pageNo: 1,
    rowCountPerPage: 10,
    sortField: "",
  };
  const [showSearchFields, setShowSearchFields] = useState(false);

  useEffect(() => {
    dispatch(publicUserActions?.setPublicUserListRow(row || rows));
  }, [row, rows]);

  useEffect(() => {
    setpaymentList(source === "RevenueReport" ? paymentList : reset);
    dispatch(
      publicUserActions.LoadPurchaseOrderTransaction(
        source === "RevenueReport" ? paymentList : reset
      )
    );
    if (source === "RevenueReport") {
      navigate(location.pathname, {
        state: {
          ...location.state,
          source: "",
        },
      });
    }
  }, [PublicUserCurrentTab === "publicuser-payments-tab"]);

  //Export
  useEffect(() => {
    if (loadPaymentExcelList && loadPaymentExcelList?.DataList?.length > 0) {
      // let title = `${row?.LastName}${row?.FirstName} Payment_List`;

      let title = `${row?.PublicUserLastName ||
        rows?.LastName ||
        rows?.PublicUserLastName ||
        infoInformationList?.LastName ||
        ""
        } ${row?.PublicUserLastName ||
        rows?.FirstName ||
        rows?.PublicUserFirstName ||
        infoInformationList?.FirstName ||
        ""
        } Payment_List`.trim();

      let generateExcelColumns = [
        "Date",
        "Order ID",
        "Inmate Name",
        "Amount ($)",
        "Status",
        "Gateway",
      ];

      let payment_List =
        loadPaymentExcelList?.DataList?.map((obj) => ({
          Date: obj?.TransactionDate,
          Order_ID: obj?.POTransactionRandomID,
          Inmate_Name: obj?.InmateName,
          Amount: obj?.PurchaseAmount.toFixed(2),
          Status:
            obj?.IsTransactionSuccess === 1
              ? "Completed"
              : obj?.IsTransactionSuccess === 0
                ? "Pending"
                : obj?.IsTransactionSuccess === -1
                  ? "Failed"
                  : "-",

          Gateway: obj?.PaymentType,
        })) || [];

      try {
        generateXlsx(payment_List, generateExcelColumns, title);

        dispatch(publicUserActions.clearPaymentExcelList());
      } catch (error) {
        console.error("Error generating Excel file:", error);
      }
    }
  }, [loadPaymentExcelList]);

  useEffect(() => {
    switch (loadPaymentConfirmCancel?.IsSucceed) {
      case 1:
        dispatch(publicUserActions.LoadPurchaseOrderTransaction(paymentList));
        showToastNotification("Payment Confirmed Successfully", "success");
        dispatch(publicUserActions.clearPaymentConfrimCancel());
        break;

      case -2:
        dispatch(publicUserActions.LoadPurchaseOrderTransaction(paymentList));
        showToastNotification("Payment Canceled Successfully", "success");
        dispatch(publicUserActions.clearPaymentConfrimCancel());
        break;

      case -3:
        showToastNotification("Operation Invalid", "error");
        dispatch(publicUserActions.clearPaymentConfrimCancel());
        break;

      default:
        // showToastNotification("Operation failed", "error");
        // dispatch(publicUserActions.clearPaymentConfrimCancel());
        break;
    }
  }, [loadPaymentConfirmCancel]);

  useEffect(() => {
    switch (POTpaymentUpdate?.IsSucceed) {
      case 0:
        dispatch(publicUserActions.LoadPurchaseOrderTransaction(paymentList));
        showToastNotification("Updated Successfully.", "success");
        dispatch(revenueReportingActions.ClearPOTpaymentUpdate());
        break;
    }
  }, [POTpaymentUpdate]);

  const handleConfirmation = (row, name) => {
    switch (name) {
      case "Confirm":
        const payload = {
          purchaseOrderTransactionID: row?.PurchaseOrderTransactionID,
          poTransactionRandomID: row?.POTransactionRandomID,
          paymentTransactionID: row?.PaymentTransactionID,
          isTransactionSuccess: 1,
          isManuallyUpdateTransaction: 1,
          manuallyUpdateType: "",
          sucessURL: "",
          createdBy: user?.ManagementUserID,
          transactionName: "",
          transactionEmail: "",
          transDate: row?.TransactionDate,
          payType: row?.PaymentType,
          isPaymentIntentMethod: row?.IsPaymentIntentMethod,
        };
        if (payload) {
          Popup({
            title: "Message",
            text: `Are you sure you want to confirm?`,
            icon: "info",
            confirmButtonText: "YES",
            cancelButtonText: "NO",
            onConfirm: () => {
              dispatch(
                publicUserActions.PurchaseOrderTransactionUpdateWeb(payload)
              );
              // Insert Management User Activity Log
              dispatch(
                authActions?.ManagementUserActivityLog({
                  ManagementUserID: user?.ManagementUserID,
                  facilityID: commonFacilityCode,
                  ProcedureName:
                    StoredProcedures?.PurchaseOrderTransactionUpdateWeb,
                  UserAction: `Confirmed  Payment Via Public User Page ( POTransactionRandomID - ${row?.POTransactionRandomID} )`,
                })
              );
            },
          });
        }

        break;

      default:
        const res = {
          purchaseOrderTransactionID: row?.PurchaseOrderTransactionID,
          poTransactionRandomID: row?.POTransactionRandomID,
          paymentTransactionID: row?.PaymentTransactionID,
          isTransactionSuccess: -1,
          isManuallyUpdateTransaction: 1,
          manuallyUpdateType: "",
          sucessURL: "",
          createdBy: user?.ManagementUserID,
          transactionName: "",
          transactionEmail: "",
          transDate: row?.TransactionDate,
          payType: row?.PaymentType,
          isPaymentIntentMethod: row?.IsPaymentIntentMethod,
        };
        if (res) {
          Popup({
            title: "Message",
            text: `Are you sure you want to cancel?`,
            icon: "info",
            confirmButtonText: "YES",
            cancelButtonText: "NO",
            onConfirm: () => {
              dispatch(
                publicUserActions.PurchaseOrderTransactionUpdateWeb(res)
              );
              // Insert Management User Activity Log
              dispatch(
                authActions?.ManagementUserActivityLog({
                  ManagementUserID: user?.ManagementUserID,
                  facilityID: commonFacilityCode,
                  ProcedureName:
                    StoredProcedures?.PurchaseOrderTransactionUpdateWeb,
                  UserAction: `Canceled  Payment Via Public User Page ( POTransactionRandomID - ${row?.POTransactionRandomID} )`,
                })
              );
            },
          });
        }
        break;
    }
  };

  const handlesendMail = (x, row) => {
    var res = x?.payload;
    if (res?.StripResponce == 0 || res?.StripResponce == -1) {
      const mailpayload = {
        name: row?.CreditCardHolderName,
        emailId: row?.TransactionEmail,
        poTransactionID: row?.PaymentTransactionID,
        poTransactionRandomID: row?.POTransactionRandomID,
        stripeResponse: res?.StripResponce == 0 ? "Transaction Pending" : "Transaction Failed",
        processingFee: row?.ProcessingFee,
        amount: row?.TotalAmount,
        transactionDate: row?.TransactionDate

      };
      dispatch(revenueReportingActions.SendMailForFailedTransaction(mailpayload));
    }
  }

  const handleUpdate = (row) => {
    const payload = {
      IsPaymentIntentMethod: true,
      date: row?.TransactionDate,
      transactionRandomID: row?.POTransactionRandomID,
      TransactionEmail: row?.TransactionEmail,
      paymentType: row?.PaymentType,
    };
    dispatch(revenueReportingActions.POTPaymantTrasactionUpdate(payload)).then((x) => {
      //handlesendMail(x, row);
    })
    // Insert Management User Activity Log
    dispatch(
      authActions?.ManagementUserActivityLog({
        ManagementUserID: user?.ManagementUserID,
        facilityID: commonFacilityCode,
        ProcedureName: StoredProcedures?.PurchaseOrderTransactionUpdateWeb,
        UserAction: `Updated  Payment Via Public User Page( POTransactionRandomID - ${row?.POTransactionRandomID} )`,
      })
    );
  };
  let sorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...paymentList };
    const newSortOrder = search.sortField?.includes(column.key)
      ? search.sortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortField = `${column.key} ${newSortOrder}`;
    setpaymentList(search);

    dispatch(
      publicUserActions.LoadPurchaseOrderTransaction({
        ...paymentList,
        sortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const handleSearch = (e) => {
    e?.preventDefault();
    setpaymentList((prev) => ({
      ...prev,
      pageNo: 1,
      rowCountPerPage: 10,
    }));
    dispatch(publicUserActions.LoadPurchaseOrderTransaction({ ...paymentList, pageNo: 1, rowCountPerPage: 10 }));
  };
  const updateSearch = { ...paymentList };
  const handleChange = (e, input) => {

    if (input) {
      const loadData = () => {
        updateSearch.pageNo = 1; // Removed ?. since updateSearch exists
        updateSearch.rowCountPerPage = 10;
        updateSearch.sortField = "";

        setpaymentList(updateSearch); // Update state before dispatching
        dispatch(publicUserActions.LoadPurchaseOrderTransaction(updateSearch));
      };

      if (input === "paymentType") {
        updateSearch[input] = e?.value || "All";
        setpaymentList(updateSearch);
        loadData();
        return;
      } else if (input === "paymentStatus") {
        updateSearch[input] = e?.value || "4";
        setpaymentList(updateSearch);
        loadData();
        return;
      } else {
        let formattedDate = fDate(e);
        setpaymentList((prev) => ({ ...prev, [input]: formattedDate }));
        return;
      }
    }

    const { name, value } = e?.target;
    setpaymentList((prev) => ({ ...prev, [name]: value }));
  };

  //
  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isValid = true;
    const updatedSearch = { ...paymentList };

    if (
      updatedSearch.noticesFromDate &&
      new Date(value) < new Date(updatedSearch.noticesFromDate)
    ) {
      // Invalid: ToDate cannot be before FromDate
      isValid = false;
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...updatedSearch,
      transactionDate:
        fieldName === "transactionDate"
          ? isValid && isValidDate
            ? value
            : ""
          : updatedSearch.transactionDate, // preserve existing value
    };
    setpaymentList(updatedParam);
  };
  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && updateSearch[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleChange(currentDate, name);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleReset = () => {
    const reset = {
      userID: row?.PublicUserID,
      transactionDate: "",
      poTransactionRandomID: "",
      paymentType: "All",
      paymentStatus: "4",
      pageNo: 1,
      rowCountPerPage: 10,
      sortField: "",
    };
    setpaymentList(reset);
    dispatch(publicUserActions.LoadPurchaseOrderTransaction(reset));
  };
  const handlePageChange = (pageNo) => {
    if (sorting) {
      sorting = false;
      return;
    }
    setpaymentList((prev) => ({
      ...prev,
      pageNo: pageNo,
    }));
    dispatch(publicUserActions.LoadPurchaseOrderTransaction({ ...paymentList, pageNo: pageNo, }));
  };

  const handleRowPerPage = (rowCount) => {
    setpaymentList((prev) => ({
      ...prev,
      rowCountPerPage: rowCount,
      pageNo: 1,
    }));
    dispatch(publicUserActions.LoadPurchaseOrderTransaction({ ...paymentList, rowCountPerPage: rowCount, pageNo: 1 }));
  };

  const columns = [
    {
      name: "Date",
      selector: (row) => row?.TransactionDate,
      key: "TransactionDate",
      cell: (row) => (
        <div title={row?.TransactionDate}>{row?.TransactionDate}</div>
      ),
      sortable: true,
    },
    {
      name: "Order ID",
      selector: (row) => row?.POTransactionRandomID,
      key: "POTransactionRandomID",
      cell: (row) => (
        <div title={row?.POTransactionRandomID}>
          {row?.POTransactionRandomID}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Inmate Name",
      selector: (row) => row?.InmateName,
      key: "InmateName",
      cell: (row) => <div title={row?.InmateName}>{row?.InmateName}</div>,
      sortable: true,
    },
    {
      name: "Amount ($)",
      key: "PurchaseAmount",
      selector: (row) => row?.PurchaseAmount?.toFixed(2),
      sortable: true,
    },

    {
      name: "Status",
      selector: (row) => row?.PaymentStatus,
      key: "PaymentStatus",
      cell: (row) => <div>{row?.PaymentStatus}</div>,
      sortable: true,
    },
    {
      name: "Gateway",
      selector: (row) => row?.PaymentType,
      key: "PaymentType",
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => row?.status,
      sortable: true,
      key: "Actions",
      cell: (row) => (
        <div>
          {
            // row?.IsTransactionSuccess === -1 &&
            //   row?.IsManuallyUpdateTransaction === 1 &&
            //   row?.IsAllowTransactionFailedUpdate === 1 &&
            // IsTransactionSuccess = -1 AND IsManuallyUpdateTransaction = 1 AND IsAllowTransactionFailedUpdate = 1
            row?.Actions === "Confirm" && (
              <div>
                <i
                  className="fa-solid fa-circle-check cursor-pointer fs-2"
                  style={{ color: "#4a9a93" }}
                  title="Confirm"
                  onClick={() => {
                    handleConfirmation(row, "Confirm");
                  }}
                ></i>
                <i
                  className="fa-solid fa-xmark cursor-pointer fs-2 ms-3"
                  style={{ color: "#cc5a5a" }}
                  title="Cancel"
                  onClick={() => {
                    handleConfirmation(row, "Cancel");
                  }}
                ></i>
              </div>
            )
          }
          {
            // (row?.IsTransactionSuccess === -1 ||
            //   row?.IsTransactionSuccess === 0) &&
            //   row?.IsManuallyUpdateTransaction === 0 &&
            //   row?.IsAllowTransactionFailedUpdate === 0 && (
            row?.Actions === "Update" && (
              <div title="Update Payment">
                <Button
                  className={"btn-xs"}
                  label="Update"
                  type="submit"
                  variant="danger"
                  icon={"fa-solid fa-pen-to-square"}
                  status={"primary"}
                  onClick={() => {
                    handleUpdate(row);
                  }}
                  disabled={false}
                />
              </div>
            )
          }
          {
            // row?.IsTransactionSuccess === 1 &&
            //   row?.IsAllowTransactionFailedUpdate === 0 && (
            //        <span className="status-open">
            //     Active
            //   </span>
            // ) : (
            //   <span className="status-Closed">
            //     InActive
            //   </span>
            // <i
            //   className="fa-solid fa-thumbs-up fs-3"
            //   style={{ color: "#4a9a93" }}
            //   title="Confirmed"
            // ></i>
            row?.Actions === "Confirmed" && (
              <span className="status-open"> Confirmed </span>
            )
          }
          {
            // row?.IsTransactionSuccess === -1 &&
            //   row?.IsManuallyUpdateTransaction === 1 &&
            //   row?.IsAllowTransactionFailedUpdate === 0 && (
            // <i
            //   className="fa-solid fa-thumbs-down fs-3"
            //   style={{ color: "#cb5a5a" }}
            //   title="Canceled"
            // ></i>
            row?.Actions === "Failed" && (
              <span className="status-Closed"> Failed </span>
            )
          }
        </div>
      ),
      //sortable: true,
      center: true,
    },
  ];
  const handleClickExcel = () => {
    const updateTotalRows = {
      ...paymentList,
      RowCountPerPage: loadPaymentList?.TotalRecordCount,
      exportExcel: true,
      pageNo: 1,
    };

    dispatch(publicUserActions.LoadPurchaseOrderTransaction(updateTotalRows));
  };

  const statusOptions = [
    { value: "4", label: "--ALL--" },
    { value: "1", label: "Success" },
    { value: "0", label: "Pending" },
    { value: "-1", label: "Failed" },
  ];
  const handleBack = () => {
    if (backTo === "RevenueReport") {
      history.navigate("RevenueReport", {
        state: { currentShowingTable: currentShowingTable },
      });
    } else {
      history.navigate("PublicUserList");
    }
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form>
        <div className="row">
          <div className="p-2 m-1 d-flex flex-wrap align-items-center">
            <div className="col-md-4 col-sm-12 d-flex flex-wrap align-items-center me-1">
              <label className="fs-5" style={{ minWidth: "150px" }}>
                Public User Last Name :
              </label>

              <strong className="fs-5 text-end mx-2">
                {row?.LastName ||
                  row?.PublicUserLastName ||
                  rows?.LastName ||
                  rows?.PublicUserLastName ||
                  infoInformationList?.LastName}
              </strong>
            </div>

            <div className="col-md-4 col-sm-12 d-flex flex-wrap align-items-center">
              <label className="fs-5" style={{ minWidth: "150px" }}>
                Public User First Name :
              </label>
              <strong className="fs-5 text-end mx-2">
                {row?.FirstName ||
                  row?.PublicUserFirstName ||
                  rows?.FirstName ||
                  rows?.PublicUserFirstName ||
                  infoInformationList?.FirstName}
              </strong>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <TextInput
                name="poTransactionRandomID"
                label="Order ID"
                value={paymentList?.poTransactionRandomID}
                handleChange={handleChange}
                placeholder="Enter Order ID"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <DateInput
                value={paymentList?.transactionDate}
                handleChange={(e) => handleChange(e, "transactionDate")}
                name="transactionDate"
                label={"Transfer Date"}
                maxDate={new Date()}
                required={false}
                minDate={new Date(2017, 0, 1)}
                isClearable={
                  paymentList?.transactionDate !== null &&
                  paymentList?.transactionDate !== ""
                }
                disabled={false}
                yearDropDown={false}
                monthDropDown={false}
                className={false ? "disabled-date-input" : ""} // Add class conditionally
                handleBlur={(e) => handleDateBlur(e, "transactionDate")}
                handleKeyDown={(e) => handleDateEnterKey(e, "transactionDate")}
              ></DateInput>
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <SelectInput
                options={paymentTypeOptions}
                value={paymentList?.paymentType}
                handleChange={(e) => handleChange(e, "paymentType")}
                isClearable={paymentList?.paymentType !== "All"}
                label="Payment Type"
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-4">
            <div className="form-floating mb-3">
              <SelectInput
                options={statusOptions}
                value={paymentList?.paymentStatus}
                handleChange={(e) => handleChange(e, "paymentStatus")}
                isClearable={paymentList?.paymentStatus !== "4"}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                label={"Payment Status"}
              />
            </div>
          </div>
        </div>

        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            onClick={handleSearch}
            status={"primary"}
            disabled={false}
            icon={"search"}
          ></Button>
          <Button
            variant="danger"
            className="me-2"
            onClick={handleReset}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  if (loading) return <CustomLoader />;

  return (
    <div>
      <div className=" p-2 ">
        <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap">
          <h4 className="inner-subheader-bg text-color">
            <i class="fa-brands fa-cc-paypal me-2"></i>Payments
          </h4>
          <Button
            label="Back"
            type="button"
            //className="btn btn-danger"
            onClick={handleBack}
            variant="danger"
            icon={"fa-solid fa-angle-left"}
            status={"primary"}
            disabled={false}
          />
        </div>
      </div>
      <div className="card shadow-sm b-r-all p-4 border border-dark-grey w-100">
        {/* Mobile only (Below md breakpoint) */}
        <div className=" d-block d-md-none">
          <div
            className=" d-flex align-items-center justify-content-between"
            style={{ background: "transparent", cursor: "pointer" }}
            onClick={toggleInformation}
          >
            <h2 className="form_title_uppercase text-color"> SEARCH</h2>
            <i
              id="itagInformation"
              className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""}`}
              style={{ fontSize: "20px" }}
            ></i>
          </div>
        </div>

        {/* Mobile only (Below md breakpoint) */}
        <div className="d-block d-md-none mt-2">
          {showSearchFields && renderSearch()}
        </div>

        {/* Web only (Desktop and above) */}
        <div className="mb-3 d-none d-md-block">
          <h2 className="form_title_uppercase text-color"> SEARCH</h2>
        </div>

        {/* Web only (Desktop and above) */}
        <div className="d-none d-md-block">{renderSearch()}</div>

        {/* <div className="d-flex flex-wrap justify-content-between align-items-center flex-wrap">
          <h2 className=" text-color form_title_uppercase">search</h2>
        </div> */}
        {/* <form>
          <div className="row">
            <div className="p-3 m-0 d-flex flex-wrap align-items-center">
              <div className="col-md-4 d-flex flex-wrap align-items-center me-4">
                <label className="fs-5" style={{ minWidth: "150px" }}>
                  Public User Last Name :
                </label>

                <strong className="fs-5 text-end mx-2">
                  {row?.LastName ||
                    row?.PublicUserLastName ||
                    rows?.LastName ||
                    rows?.PublicUserLastName ||
                    infoInformationList?.LastName}
                </strong>
              </div>

              <div className="col-md-4 d-flex flex-wrap align-items-center">
                <label className="fs-5" style={{ minWidth: "150px" }}>
                  Public User First Name :
                </label>
                <strong className="fs-5 text-end mx-2">
                  {row?.FirstName ||
                    row?.PublicUserFirstName ||
                    rows?.FirstName ||
                    rows?.PublicUserFirstName ||
                    infoInformationList?.FirstName}
                </strong>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <div className="form-floating mb-3">
                <TextInput
                  name="poTransactionRandomID"
                  label="Order ID"
                  value={paymentList?.poTransactionRandomID}
                  handleChange={handleChange}
                  placeholder="Enter Order ID"
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-floating mb-3">
                <DateInput
                  value={paymentList?.transactionDate}
                  handleChange={(e) => handleChange(e, "transactionDate")}
                  name="transactionDate"
                  label={"Transfer Date"}
                  maxDate={new Date()}
                  required={false}
                  minDate={new Date(2017, 0, 1)}
                  isClearable={
                    paymentList?.transactionDate !== null &&
                    paymentList?.transactionDate !== ""
                  }
                  disabled={false}
                  yearDropDown={false}
                  monthDropDown={false}
                  className={false ? "disabled-date-input" : ""} // Add class conditionally
                  handleBlur={(e) => handleDateBlur(e, "transactionDate")}
                  handleKeyDown={(e) =>
                    handleDateEnterKey(e, "transactionDate")
                  }
                ></DateInput>
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-floating mb-3">
                <SelectInput
                  options={paymentTypeOptions}
                  value={paymentList?.paymentType}
                  handleChange={(e) => handleChange(e, "paymentType")}
                  isClearable={paymentList?.paymentType !== "All"}
                  label="Payment Type"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="form-floating mb-3">
                <SelectInput
                  options={statusOptions}
                  value={paymentList?.paymentStatus}
                  handleChange={(e) => handleChange(e, "paymentStatus")}
                  isClearable={paymentList?.paymentStatus !== "4"}
                  isMulti={false}
                  closeMenuOnSelect={true}
                  isDisabled={false}
                  isLoading={false}
                  label={"Payment Status"}
                />
              </div>
            </div>
          </div>

         
          <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
            <Button
             
              className="me-2"
              label={"SEARCH"}
              type={"submit"}
              onClick={handleSearch}
              status={"primary"}
              disabled={false}
              icon={"search"}
            ></Button>
            <Button
              variant="danger"
              className="me-2"
              onClick={handleReset}
              label={"RESET"}
              type={"button"}
              status={"secondary"}
              disabled={false}
              icon={"fa-solid fa-rotate-right"}
            />
          </div>
        </form> */}
      </div>
      <div className="mt-3">
        <div className="d-flex flex-wrap  justify-content-end mb-3">
          {loadPaymentList?.DataList?.length > 0 && (
            <ExcelExport
              variant="soft-gray"
              handleExcelExport={handleClickExcel}
            />
          )}
        </div>

        <Table
          columns={columns}
          data={loadPaymentList?.DataList}
          pagination
          onChangeRowsPerPage={handleRowPerPage}
          onChangePage={handlePageChange}
          totalRowCount={loadPaymentList?.TotalRecordCount}
          currentPage={paymentList?.pageNo}
          paginationPerPage={paymentList.rowCountPerPage}
          onSort={handleSort}
          serverSideSort
          sortColumn={paymentList?.sortField?.split(" ")[0]}
          sortDirection={paymentList?.sortField?.split(" ")[1]}
        />
      </div>
    </div>
  );
}
export default React.memo(PublicUserPayment);
